import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { RemoveClassFromBody } from '../../utils/utils';

import Toolbar from '../../components/Toolbar/Toolbar';
import Sidebar from '../../components/Sidebar/Sidebar';


import CustomerWebPortal from '../Customer-web-portal';


class Layout extends Component {

    render () {
        RemoveClassFromBody();
        return (
            <div>
                <Toolbar />
                <Sidebar />
                <aside className="page-wrapper">

                    <Switch>
                        <Route path="/"  component={ CustomerWebPortal } />
                        <Redirect to="/" />
                    </Switch>

                </aside>
            </div>
        )
    }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js